require("collapse");

var GRaygun = require("./modules/GRaygun");
var graygunner = new GRaygun();

var ENSender = require("./modules/ENSender");
var ensender = new ENSender();

var windowSize;

/**
 * [accessLanguage description]
 * @type {Object}
 */
var accessLanguage = {};
accessLanguage.go = function () {
  var $html = $("html");

  $(".access-toggle").click(function (event) {
    event.preventDefault();
    $html.toggleClass("accessible-text");
  });
};

/**
 * [handleMenu description]
 * @return {[type]} [description]
 */
handleMenu = function () {
  var clickType = "click";
  var isiOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  var isMobile = false;

  if ($(window).width() < 901) {
    isMobile = true;
  }

  if (isiOS == true && isMobile == true) {
    clickType = "click touchend";
  }

  $(this)
    .on("mouseover", function () {
      var the_parent = jQuery(this);
      var the_child = the_parent.children(".sub-menu");

      if (the_child.length > 0) {
        var x_pos =
          jQuery(window).width() - the_child.offset().left - the_child.width();
        //jQuery(this).html(x_pos);
        if (x_pos < 0) {
          the_child.css({
            "margin-left": x_pos + "px",
          });
        }
      }

      //  hide search if visible
      if ($("#avia-menu").hasClass("searchOpen")) {
        $("#avia-menu").removeClass("searchOpen");
      }
    })
    // .on("mouseenter",function(){
    //   if($(".main_menu-overlay").length === 0){
    //     $(".av-main-nav").append('<div class="main_menu-overlay"></div>');
    //   }
    // })
    // .on("mouseleave",function(e){
    //   $(".main_menu-overlay").remove();
    // })
    .on(clickType, "a", function (event) {
      var $this = $(this);
      //All sub-menu triggers should be preventDefaulted for mobile, only the 2nd level ones should be on desktop
      if (windowSize !== "mobile" && $this.closest(".sub-menu").length > 0) {
        return true;
      }
      //if the link has siblings, open the sub-menu instead of going to the target page
      if ($this.siblings().length > 0) {
        event.preventDefault();

        //remove other mobileOpened items
        $this.parent().siblings(".mobileOpen").removeClass("mobileOpen");

        //Open this one up
        // debugger;
        $this.parent().toggleClass("mobileOpen");
      }
    });

  //  ovveride some bug from theme defaults that are causing the sub-menu containers to be
  //  visibility:hidden, opacity: 0, yet simutaneously display:block
  // window.setTimeout(function() {

  //   var the_parent = jQuery(this);
  //   var the_child = the_parent.children(".sub-menu");

  //   the_child.css('display', 'none');
  // }, 500);

  $(".mobileMenu_bottom_container").parent().addClass("mobile_show");
};

/**
 * [handleMobile description]
 * @return {[type]} [description]
 */
handleMobile = function () {
  var clickType = "click";
  var isiOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

  if (isiOS) {
    clickType = "click touchend";
  }

  $(this)
    .on(clickType, ".mobile-menu-toggle", function () {
      $("#header_main_alternate #avia-menu").toggleClass("mobileOpen");
      $("html").toggleClass("mobileOpen");
      // remove URLs from mobile nav selections so they don't trigger when menu opens
      $('.av-main-nav > li > a[role="menuitem"]')
        .removeAttr("href")
        .addClass("mobile-menu-item");

      //  hide search
      $("#header_main_alternate .mobile-search-input").hide();
      $("#header_main_alternate #avia-menu").removeClass("searchOpen");
    })
    .on(clickType, ".mobile-search-toggle", function () {
      $("#header_main_alternate .mobile-search-input").toggle();
      $("#header_main_alternate #avia-menu").toggleClass("searchOpen");

      //  hide menu
      $("#header_main_alternate #avia-menu").removeClass("mobileOpen");
      $("html").removeClass("mobileOpen");
      $("input.st-default-search-input").focus();
    });
};

heroAnimation = function (opts) {
  if (this.length === 0) return;

  opts = $.extend(
    {
      duration: 250,
      pause: 3000,
    },
    opts
  );

  var $frames = this.find(".hero-frame");
  var frameIndex = 0; //we assume we're always on the first page
  var landingTime = Date.now();

  window.setTimeout(function () {
    window.setTimeout(nextFrame, 100);
  }, 100);

  /**
   * [nextFrame description]
   * @return {[type]} [description]
   */
  var nextFrame = function () {
    if (
      $frames.eq(frameIndex).find(".js-additional:not(.is-visible)").length > 0
    ) {
      $frames
        .eq(frameIndex)
        .find(".js-additional:not(.is-visible)")
        .addClass("is-visible")
        .animate({ opacity: 1 }, opts.duration, pauseFrame);
      // .fadeIn(opts.duration, pauseFrame);
    }

    //if there is a next frame...
    else if ($frames.eq(frameIndex + 1).length > 0) {
      $frames.eq(frameIndex).fadeOut(opts.duration, function () {
        frameIndex++;
        $frames.eq(frameIndex).fadeIn(opts.duration, pauseFrame);
      });
    }
  };

  var pauseFrame = function () {
    setTimeout(nextFrame, opts.pause);
  };

  return {
    nextFrame: nextFrame,
    pauseFrame: pauseFrame,
  };
};

function handleSignup() {
  var self = this;
  this.on("submit", function (e) {
    e.preventDefault();
    ensender.send({
      form: self,
      data: self.serializeArray(),
      success: function (data, status, xhr) {
        if (data.messages.length == 0) {
          self.hide();
          $(".js-signup-ty").fadeToggle();
        }
      },
    });
  });
}

function handlePostSelect(e) {
  var post = $(e.target).val();

  var a = document.createElement("a");
  a.href = post;

  if (post && a.hostname === document.location.hostname) {
    window.location = post;
  }
}

/**
 * [handleWindowSize description]
 * @return {[type]} [description]
 */
function handleWindowSize() {
  getBrowserSize();
}

function handleSVG() {
  jQuery("img.js-inline-svg").each(function () {
    var $img = jQuery(this);
    var imgID = $img.attr("id");
    var imgClass = $img.attr("class");
    var imgURL = $img.attr("src");

    $.ajax({
      type: "GET",
      url: imgURL,
      dataType: "xml",
      // cache: false,
      crossDomain: true,
      error: function (xhr, status, errorThrown) {
      },
      success: function (data, textStatus, jqXHR) {
        // Get the SVG tag, ignore the rest
        var $svg = jQuery(data).find("svg");

        // Add replaced image's ID to the new SVG
        if (typeof imgID !== "undefined") {
          $svg = $svg.attr("id", imgID);
        }
        // Add replaced image's classes to the new SVG
        if (typeof imgClass !== "undefined") {
          $svg = $svg.attr("class", imgClass + " replaced-svg");
        }

        // Remove any invalid XML tags as per http://validator.w3.org
        $svg = $svg.removeAttr("xmlns:a");

        // Check if the viewport is set, if the viewport is not set the SVG wont't scale.
        if (
          !$svg.attr("viewBox") &&
          $svg.attr("height") &&
          $svg.attr("width")
        ) {
          $svg.attr(
            "viewBox",
            "0 0 " + $svg.attr("height") + " " + $svg.attr("width")
          );
        }

        // Replace image with new SVG
        $img.replaceWith($svg);
      }, // success
    }); // $.ajax

    // jQuery.get(imgURL, function(data) {
    //     // Get the SVG tag, ignore the rest
    //     var $svg = jQuery(data).find('svg');

    //     // Add replaced image's ID to the new SVG
    //     if(typeof imgID !== 'undefined') {
    //         $svg = $svg.attr('id', imgID);
    //     }
    //     // Add replaced image's classes to the new SVG
    //     if(typeof imgClass !== 'undefined') {
    //         $svg = $svg.attr('class', imgClass+' replaced-svg');
    //     }

    //     // Remove any invalid XML tags as per http://validator.w3.org
    //     $svg = $svg.removeAttr('xmlns:a');

    //     // Check if the viewport is set, if the viewport is not set the SVG wont't scale.
    //     if(!$svg.attr('viewBox') && $svg.attr('height') && $svg.attr('width')) {
    //         $svg.attr('viewBox', '0 0 ' + $svg.attr('height') + ' ' + $svg.attr('width'))
    //     }

    //     // Replace image with new SVG
    //     $img.replaceWith($svg);

    // }, 'xml');
  });
}

function handleMenuDOM() {
  //  mobile menu
  var languageLink = $(".access_language a").attr("href");
  var languageText = $(".access_language .other-language").text();
  var languageLinkHTML =
    '<a href="' + languageLink + '">' + languageText + "</a>";

  var mobileLanguageSwitch = $(".mobileMenu_bottom_info--language span");

  mobileLanguageSwitch.html(languageLinkHTML);

  //  wait for avia js file to add the .dropdown_available element
  window.setTimeout(function () {
    $("#avia-menu .topLevel-sub-menu > a").append(
      '<span class="dropdown_available"><div class="square"><span class="plus"></span><span class="minus"></span></div></span>'
    );
    //$('.dropdown_available').append('<div class="square"><span class="plus"></span><span class="minus"></span></div>');
  }, 500);

  //  desktop menu
  //  add contact subnav items

  $("li.profile-icon a").prepend(
    '<div class="contact-icon contact-icon--profile"></div>'
  );
  $("li.heart-icon a").prepend(
    '<div class="contact-icon contact-icon--heart"></div>'
  );
  $("li.news-icon a").prepend(
    '<div class="contact-icon contact-icon--news"></div>'
  );
}

$(document).ready(function () {
  accessLanguage.go();
  handleMenu.call($("#avia-menu > .menu-item"));
  handleMobile.call($(".bar-main-menu"));
  // Comment this out to get form working
  if (
    $("body").hasClass(
      "category-sunday-mass page-template-sundaymass-landing single-sunday-mass"
    )
  ) {
  } else {
    handleSignup.call($(".js-signup"));
  }

  function customAttrFields() {
    $("#nf-field-437").attr("autocomplete", "given-name");
    $("#nf-field-442").attr("autocomplete", "address-level1");
  }

  var checkExist = setInterval(function () {
    if ($("#nf-field-442").length) {
      clearInterval(checkExist);
      customAttrFields();
    }
  }, 100); // check every 100ms

  heroAnimation.call($(".js-heroAnimated"));

  handleWindowSize();
  $(window).on("resize", handleWindowSize);
  $(".grPostSelect").on("change", handlePostSelect);

  handleSVG();
  handleMenuDOM();
  handleBreadcrumbingSimplified();
  if (!$(".alert").hasClass("alert_global_disabled")) {
    handleAlertbox();
  }

  handleHomeQuotes();

  //replacing undefined aria-label
  if ($('a[aria-label="undefined (opens in a new tab)"]').length) {
    var href_value = $('a[aria-label="undefined (opens in a new tab)"]').attr(
      "href"
    );
    $('a[aria-label="undefined (opens in a new tab)"]').attr(
      "aria-label",
      href_value
    );
  }

  //replacing role attr of menubar
  if ($('li[role="menuitem"]').length) {
    $('li[role="menuitem"]').attr("role", "menubar");
  }

  //triggering anchor tag on different click elements
  $(".mh-article-card").on("click", function (event) {
    const url = event.target.closest("article").dataset.url;
    if (url) {
      window.location.href = url;
    }
  });

  //aria-hidden
  if ($('a[class="prev-slide"]').length) {
    $('a[class="prev-slide"]').attr("aria-hidden", "false");
  }

  if ($('a[class="next-slide"]').length) {
    $('a[class="next-slide"]').attr("aria-hidden", "false");
  }

  //button without label (carousel plugin)
  if ($('button[class="owl-dot"]').length) {
    $('button[class="owl-dot"]').attr("aria-label", "carousel-button");
  }

  //adding aria-label to iframe tag
  if ($("p > iframe").length) {
    $("p > iframe").attr("aria-label", "Sunday Mass Homily Video");
  }
});

var localCity;
var localCountry;
var locationData;
var locationCheckedSession;

var maxHeight;
var animationTime;
var minimized = false;

function handleAlertbox() {
  maxHeight = $(".alert_primary .version_maximized").outerHeight();

  //check sessionStorage, if minimized is true, present only minimized version
  var minimizedStatus = sessionStorage.getItem("alertbox_minimized");
  if (minimizedStatus == "true") {
    maxHeight = $(".alert_primary .version_maximized").outerHeight();
    if (maxHeight < 300) {
      animationTime = 130;
    } else {
      animationTime = 200;
    }
    minimizeAlertbox(0);
    minimized = true;
  }

  // //check if location information stores in localStorage
  localCity = localStorage.getItem("localCity");
  localCountry = localStorage.getItem("localCountry");
  locationCheckedSession = sessionStorage.getItem("locationCheckedSession");

  if (localCity == null && localCountry == null) {
    //if we also haven't re-checked this new browser session, check again
    if (locationCheckedSession == null) {
      getLocation();
    }
  } else {
    //only re-check location if it hasn't been checked this new browser session
    if (locationCheckedSession == null) {
      getLocation();
      // $('.alert').removeClass('page_load-hidden');
    } else {
      evaluateLocation(localCity, localCountry);
      // $('.alert').removeClass('page_load-hidden');
    }
  }

  //LAUNCH DATE rules
  var launchDate = new Date($(".schedule_launch").html());
  var endDate = new Date($(".schedule_end").html());
  var today = new Date();

  if (isNaN(endDate)) {
    launchDate = today;
  }

  if (isNaN(endDate)) {
    endDate = today;
  }

  //compare dates
  if (launchDate <= today && endDate >= today) {
    //meaning that today is either the launch date itself, or is past the launch date, therefore the alertbox should be shown.
    //first check if it doesn't already have class alert-disabled, so as to not override higher level category, page, or location based rules.
    if (!$(".alert").hasClass("alert-disabled")) {
      $(".alert").removeClass("alert-disabled");
      $(".alert").addClass("alert-enabled");
    }
  } else {
    //today's date sits outside the range of dates set in the admin
    $(".alert").removeClass("alert-enabled");
    $(".alert").addClass("alert-disabled");
  }

  //ANIMATION events

  //event handler for primary version
  $(".alert_primary .version_maximized .alert-toggle_minimize").click(
    function () {
      //get current height of maximized version
      maxHeight = $(".alert_primary .version_maximized").outerHeight();
      if (maxHeight < 300) {
        animationTime = 130;
      } else {
        animationTime = 200;
      }
      minimizeAlertbox(animationTime);
      minimized = true;
      //set sessionStorage variable
      sessionStorage.setItem("alertbox_minimized", "true");
    }
  );

  //separate event handler for secondary version
  $(".alert_secondary .version_maximized .alert-toggle_minimize").click(
    function () {
      //get current height of maximized version
      maxHeight = $(".alert_secondary .version_maximized").outerHeight();
      if (maxHeight < 300) {
        animationTime = 130;
      } else {
        animationTime = 200;
      }
      minimizeAlertbox(animationTime);
      minimized = true;
      //set sessionStorage variable
      sessionStorage.setItem("alertbox_minimized", "true");
    }
  );

  $(".version_minimized .alert-toggle_maximize").click(function () {
    maximizeAlertbox(maxHeight, animationTime);
    minimized = false;
  });

  //WINDOW SCROLL event

  $(window).scroll(function (event) {
    var scroll = $(window).scrollTop();
    if (scroll > 300 && minimized == false) {
      maxHeight = $(".alert_primary .version_maximized").outerHeight();

      //if secondary version is visible, get that height instead
      if (!$(".alert_secondary").hasClass("alert_location-disabled")) {
        maxHeight = $(".alert_secondary .version_maximized").outerHeight();
      }

      if (maxHeight < 300) {
        animationTime = 130;
      } else {
        animationTime = 200;
      }
      minimizeAlertbox(animationTime);
      minimized = true;
      //set sessionStorage variable
      sessionStorage.setItem("alertbox_minimized", "true");
    }
  });

  $(".alert").removeClass("page_load-hidden");
}

function getLocation() {
  $.ajax({
    type: "GET",
    url: "https://json.geoiplookup.io",
    dataType: "jsonp",
    cache: false,
    crossDomain: true,
    error: function (xhr, status, errorThrown) {
      console.log(status, errorThrown);
    },
    success: function (data, textStatus, jqXHR) {
      locationData = data;
      localCity = data.city;
      localCountry = data.country_code;

      //save location to a localStorage variable
      localStorage.setItem("localCity", localCity);
      localStorage.setItem("localCountry", localCountry);

      sessionStorage.setItem("locationCheckedSession", "checked");

      evaluateLocation(localCity, localCountry);
    }, // success
  }); // $.ajax
}

function categorizePageCondition(version) {
  var pageQuads = [];
  var valuePushed = false;

  if ((version = "primary")) {
    if (
      $(".alert_primary").hasClass("location_chicago-exclude") ||
      $(".alert_primary").hasClass("location_chicago-include")
    ) {
      pageQuads.push("chicago");
      valuePushed = true;
    }
    if (
      $(".alert_primary").hasClass("location_national-exclude") ||
      $(".alert_primary").hasClass("location_national-include")
    ) {
      pageQuads.push("national");
      valuePushed = true;
    }
    if (valuePushed == false) {
      //no location inclusion or exclusion rules set
      pageQuads.push("none");
    }
  } else if ((version = "secondary")) {
    if (
      $(".alert_secondary").hasClass("secondary_location_chicago-exclude") ||
      $(".alert_secondary").hasClass("secondary_location_chicago-include")
    ) {
      pageQuads.push("chicago");
      valuePushed = true;
    }
    if (
      $(".alert_secondary").hasClass("secondary_location_national-exclude") ||
      $(".alert_secondary").hasClass("secondary_location_national-include")
    ) {
      pageQuads.push("national");
      valuePushed = true;
    }
    if (valuePushed == false) {
      //no location inclusion or exclusion rules set
      pageQuads.push("none");
    }
  }
  //Future implementation
  //alertbox has region1-exclude, or region1-include

  return pageQuads;
}

function categorizeLocationCondition(localCity, localCountry) {
  if (localCountry == "US" && localCity.indexOf("Chicago") >= 0) {
    return "chicago";
  } else if (localCountry == "US" && !localCity.indexOf("Chicago") >= 0) {
    return "national";
  } else {
    return "international";
  }
}

function evaluateGlobalRule() {
  if (
    $(".alert_primary").hasClass("location_chicago-exclude") ||
    $(".alert_primary").hasClass("location_region1-exclude") ||
    $(".alert_primary").hasClass("location_national-exclude")
  ) {
    return "globalInclusion";
  } else if (
    $(".alert_primary").hasClass("location_chicago-include") ||
    $(".alert_primary").hasClass("location_region1-include") ||
    $(".alert_primary").hasClass("location_national-include")
  ) {
    return "globalExclusion";
  } else {
    return "none";
  }
}

function evaluateLocation(localCity, localCountry) {
  //get page rule condition (quadrant)
  var pageQuadrant = categorizePageCondition();

  //get location condition (quadrant)
  var locationQuadrant = categorizeLocationCondition(localCity, localCountry);

  //get starting global rule
  var startingRule = evaluateGlobalRule();

  //now compare quadrant values to hide or show
  if (startingRule == "globalInclusion") {

    if (pageQuadrant.length > 0) {
      pageQuadrant.forEach(function (currentValue, index, arr) {
        //for each of the quadrant rules added to the page, eveluate
        if (currentValue == locationQuadrant) {
          //exclude page
          $(".alert").addClass("page_load-hidden");
          $(".alert_primary").removeClass("alert-enabled");
          $(".alert_primary").addClass("alert-disabled");
        } else {
          //continue including page, do nothing in this case
          $(".alert").removeClass("page_load-hidden");
        }
      });
    }
    $(".alert").removeClass("page_load-hidden");
  } else if (startingRule == "globalExclusion") {
    if (pageQuadrant.length > 0) {
      pageQuadrant.forEach(function (currentValue, index, arr) {
        //for each of the quadrant rules added to the page, eveluate
        if (currentValue == locationQuadrant) {
          //include page
          //check if the primary version hasn't been marked as disabled by prior rules
          //don't change disable and enable rules, just remove page hidden class and show what is already there
          // $('.alert_primary').removeClass('alert-disabled');
          // $('.alert_primary').addClass('alert-enabled');
          $(".alert").removeClass("page_load-hidden");
        } else {
          //continue excluding page, do nothing in this case
          // $('.alert').addClass('page_load-hidden');
          // $('.alert_primary').addClass('alert-disabled');
          // $('.alert_primary').removeClass('alert-enabled');
          $(".alert").addClass("page_load-hidden");
        }
      });
    }
  } else if (startingRule == "none") {
    //no location rules to evaluate, do nothing
  }

  var pageQuadrantSecondary = categorizePageCondition();

  //check if secondary version exists.
  if ($(".alert_secondary").hasClass("alert-enabled")) {
    if (pageQuadrantSecondary.length > 0) {
      pageQuadrantSecondary.forEach(function (currentValue, index, arr) {
        //for each of the quadrant rules added to the page, eveluate
        if (currentValue == locationQuadrant) {
          //include page
          //hide primary version
          $(".alert").addClass("page_load-hidden");
          $(".alert_primary").removeClass("alert-enabled");
          $(".alert_primary").addClass("alert-disabled");

          //show secondary version
          $(".alert_secondary").removeClass("alert-disabled");
          $(".alert_secondary").addClass("alert-enabled");
          $(".alert_secondary").removeClass("alert_location-disabled");
          $(".alert").removeClass("page_load-hidden");
        } else {
          //continue excluding page, do nothing in this case
        }
      });
    }
  }
}

function minimizeAlertbox(animationTime) {
  maxHeight = $(".alert_primary .version_maximized").outerHeight();

  //hide minimize button
  $(".version_maximized .alert-toggle_minimize").fadeTo(
    animationTime,
    0,
    function () {}
  );

  //fade out content
  $(".version_maximized .alert_content").fadeTo(animationTime, 0, function () {
    $(".version_minimized .alert_content").fadeTo(0, 0);
    $(".version_maximized").animate({ height: "85px" });
  });

  var delay = animationTime * 2 + 150;

  setTimeout(function () {
    //hide version minimized
    $(".version_maximized").removeClass("alert-visible");
    $(".version_maximized").addClass("alert-hidden");

    //reveal new content
    $(".version_minimized").removeClass("alert-hidden");
    $(".version_minimized").addClass("alert-visible");
    $(".version_minimized .alert_content").fadeTo(animationTime, 1);
    //show minimize button
    $(".version_minimized .alert-toggle_maximize").fadeTo(
      animationTime,
      1,
      function () {}
    );
  }, delay);
}

function maximizeAlertbox(maxHeight, animationTime) {
  //hide minimize button
  $(".version_minimized .alert-toggle_maximize").fadeTo(
    animationTime,
    0,
    function () {}
  );

  //fade out content
  $(".version_minimized .alert_content").fadeTo(animationTime, 0, function () {
    $(".version_maximized .alert_content").fadeTo(0, 0);
    // $(this).delay(animationTime);
    //hide version minimized
    $(".version_minimized").removeClass("alert-visible");
    $(".version_minimized").addClass("alert-hidden");

    //reveal new content
    $(".version_maximized").removeClass("alert-hidden");
    $(".version_maximized").addClass("alert-visible");
    $(".version_maximized").animate({ height: maxHeight });
  });

  var delay = animationTime * 2 + 150;

  setTimeout(function () {
    $(".version_maximized .alert_content").fadeTo(animationTime, 1);
    //show minimize button
    $(".version_maximized .alert-toggle_minimize").fadeTo(
      animationTime,
      1,
      function () {}
    );
  }, delay);
}

/**
 * Deprecated function for original version of breadcrumbing.
 * This function relied on the following setup for the "Separator between breadcrumbs"
 * setting within the Yoast SEO Breadcrumbing Appearance configuration in the CMS:
 * <span class="primary_separator">/</span><span class="mobile_separator">◄</span>
 */
function handleBreadcrumbing() {

  var depth = $(".breadcrumb_last").parentsUntil(".page-breadcrumb").length;
  //add override in case this is the Sunday Mass landing page
  if (
    $("body").hasClass("page-template-sundaymass-landing") ||
    $("body").hasClass("page-template-experts-archive")
  ) {
    depth = 2;
  }
  if (
    $("body").hasClass("page-template-blog-new") ||
    $("body").hasClass("resource-template-default") ||
    $("body").hasClass("experts-template-default")
  ) {
    depth = 3;
  }
  if ($("body").hasClass("single-post")) {
    depth = 4;
  }
  if (depth == 2) {
    $(".page-breadcrumb").addClass("two_levels");
    $(".two_levels").prepend(
      '<span class="mobile_separator">&#9668;&nbsp;</span>'
    );
  } else if (depth == 3) {
    $(".page-breadcrumb").addClass("three_levels");
    $(".three_levels span span span a").first().addClass("second_item");
    $(".two_levels").prepend(
      '<span class="mobile_separator">&#9668;&nbsp;</span>'
    );
  } else if (depth == 4) {
    $(".page-breadcrumb").addClass("four_levels");
    $(".four_levels span span span a").first().addClass("second_item");
  }

  if ($("html").attr("lang") == "es-ES") {
    $(".home_tag").html("Página Principal");
  }

  //add event handler to top level menu items
  $(".main_menu .menu-item-top-level").on("click", function () {
    var url = $(this).find("a").first()[0].href;
    window.open(url, "_self");
  });

  $(".main_menu .sub-menu .nav_section_column").each(function () {
    $(this)
      .find("a")
      .first()
      .on("click", function (e) {
        //e.preventDefault();
        e.stopPropagation();
      });
  });

  //if page is Sunday Mass archive, replace entire breadbcrumb container with this custom override
  if ($("body").hasClass("category-18")) {
    $(".page-breadcrumb").html(
      '<span><span><a href="http://mercyhome.org/"><span class="home_tag">Home</span></a> <span class="primary_separator">/</span><span class="mobile_separator">◄</span> <span><a href="http://mercyhome.org/page-sunday-mass/" class="second_item">Sunday Mass</a><span class="primary_separator">/</span><span class="mobile_separator">◄</span> <span class="breadcrumb_last">Archive</span></span></span></span>'
    );
    $(".page-breadcrumb").removeClass("four_levels").addClass("three_levels");
  }
}

/**
 * Function created for simplified breadcrumbing functionality.
 */
function handleBreadcrumbingSimplified() {
  if ($("html").attr("lang") == "es-PR") {
    $(".home_tag").html("Página Principal");
  }

  //add event handler to top level menu items
  $(".main_menu .menu-item-top-level").on("click", function () {
    var url = $(this).find("a").first()[0].href;
    window.open(url, "_self");
  });

  $(".main_menu .sub-menu .nav_section_column").each(function () {
    $(this)
      .find("a")
      .first()
      .on("click", function (e) {
        //e.preventDefault();
        e.stopPropagation();
      });
  });

  //if page is Sunday Mass archive, replace entire breadbcrumb container with this custom override
  if ($("body").hasClass("category-18")) {
    $(".page-breadcrumb").html(
      '<span><span><a href="http://mercyhome.org/"><span class="home_tag">Home</span></a> <span class="primary_separator">/</span><span class="mobile_separator">◄</span> <span><a href="http://mercyhome.org/page-sunday-mass/" class="second_item">Sunday Mass</a><span class="primary_separator">/</span><span class="mobile_separator">◄</span> <span class="breadcrumb_last">Archive</span></span></span></span>'
    );
    $(".page-breadcrumb").removeClass("four_levels").addClass("three_levels");
  }
}

function handleHomeQuotes() {
  if (document.querySelector(".home-quotes--single") == null) {
    //no quote on page, hide parent container
    $(".home-quotes").hide();
  }
}

/**
 * [getBrowserSize description]
 * @return {[type]} [description]
 */
function getBrowserSize() {
  if (window.getComputedStyle) {
    windowSize = window
      .getComputedStyle(document.body, ":after")
      .getPropertyValue("content");
    windowSize = windowSize.replace(/["']/g, "");
  }
}

/**
 * targets og:image meta tag, uses regex to replace // URL with * https://
 */
$(document).ready(function () {
  if (document.querySelector("meta[property='og:image']")) {
    var OGimage = $("meta[property='og:image']").attr("content");
    OGimage = OGimage.replace(/^\/\/|http:\/\//, "https://");
    $("meta[property='og:image']").attr("content", OGimage);
  }

  // *********************************

  // Day Shift Digital Work

  // *********************************

  //  Animation on scroll initialize
  if (typeof AOS !== "undefined") {
    AOS.init();
  }

  // Count up numbers
  var countUpNumbers = function () {
    $(".home-about--info").each(function () {
      var $this = $(this),
        countTo = $this.attr("data-count");
      $({
        countNum: $this.text(),
      }).animate(
        {
          countNum: countTo,
        },
        {
          duration: 2000,
          easing: "swing",
          step: function () {
            $this.text(Math.floor(this.countNum).toLocaleString());
          },
          complete: function () {
            $this.text(this.countNum.toLocaleString());
          },
        }
      );
    });
  };

  var countUpMHNumbers = function (e) {
    var $this = e.find(".home-about--info"),
      countTo = $this.attr("data-count");
    $({
      countNum: $this.text(),
    }).animate(
      {
        countNum: countTo,
      },
      {
        duration: 2000,
        easing: "swing",
        step: function () {
          $this.text(Math.floor(this.countNum).toLocaleString());
        },
        complete: function () {
          $this.text(this.countNum.toLocaleString());
        },
      }
    );
  };

  $(".mh-animate").each(function () {
    var e = $(this);
    var counted = false;
    $(window).on("scroll", function () {
      if (
        e.offset().top < $(window).scrollTop() + $(window).height() * 0.8 &&
        counted == false
      ) {
        countUpMHNumbers(e);
        counted = true;
        //$(window).off('scroll');
      }
    });
  });

  if (document.getElementById("home-about--numbers")) {
    $(window).on("scroll", function () {
      var element = document.getElementById("home-about--numbers");
      var viewportOffset = element.getBoundingClientRect();
      var elementTop = viewportOffset.top;
      var windowHeight = $(window).height();
      if (elementTop <= windowHeight) {
        countUpNumbers();
        $(window).off("scroll");
      }
    });
  }

  //Video Resize
  function videoResize() {
    $(".wp-block-embed-youtube").each(function () {
      var w = $(this).find("iframe").attr("width");
      var h = $(this).find("iframe").attr("height");
      $(this)
        .find(".wp-block-embed__wrapper")
        .css({
          "padding-top": (h / w) * 100 + "%",
        });
    });
    $(".single-header--video-container").each(function () {
      var w = $(this).find("iframe").attr("width");
      var h = $(this).find("iframe").attr("height");
      $(this).css({
        "padding-top": (h / w) * 100 + "%",
      });
    });
  }
  videoResize();

  // Scroll to local listings section
  $(".sm-local-link").click(function (e) {
    e.preventDefault();
    document.querySelector("#local-listings").scrollIntoView({
      behavior: "smooth",
    });
  });

  // Insert Flexbox for new Guide Request layout
  $("#ninja_forms_form_11_all_fields_wrap").addClass("now-flex");

  // Setup Flickity for Sunday Mass Homily Template
  if ($("body").hasClass("sunday-mass-template-default")) {
    if ($("section.sundaymass-video--container").hasClass("multiple")) {
      var flkty = new Flickity(".sundaymass-rotator", {
        wrapAround: true,
      });
      flkty;
    }
  }

  if ($("body").hasClass("sunday-mass-template-default")) {
    $("#nf-field-52").css("-webkit-appearence", "none");
  }

  // On click of guide link scroll down to guide
  $("#guide-link").on("click", function (e) {
    e.preventDefault();
    // Scroll to a certain element
    document.querySelector("#guide").scrollIntoView({
      behavior: "smooth",
    });
  });

  // Ajax load more
  $("#sm-load-more").on("click", function () {
    var that = $(this);
    var page = that.data("page");
    var newPage = page + 1;
    var ajaxUrl = that.data("url");
    var loading = $(".loader").addClass("loading");
    that.hide();
    $.ajax({
      url: ajaxUrl,
      type: "post",
      data: {
        page: newPage,
        action: "sm_load_more",
      },
      error: function (response) {
      },
      success: function (response) {
        that.show();
        that.data("page", newPage);
        $(".sm-archive--container").append(response);
        loading.removeClass("loading");
        if (response.length == 0) {
          that.text("There are no more posts");
        }
      },
    });
  });

  var last_scroll = 0;
  // Scroll and Update URL
  if ($("body").hasClass("category-sunday-mass")) {
    $(window).scroll(function () {
      var scroll = $(window).scrollTop();
      if (Math.abs(scroll - last_scroll) > $(window).height() * 0.1) {
        last_scroll = scroll;
        // $('.sm-page-limit').each(function(index){
        //   if(isVisible( $(this) ) ) {
        //     history.replaceState(null, null, $(this).attr("data-page"));
        //     return(false);
        //   }
        // });
      }
    });
  }

  // Fallback for IE Object Fit Cover
  function ImgObjectFit_Anchor() {
    $("img.obj-fit").each(function () {
      var imgSrc = $(this).attr("src");
      var fitType = "cover";
      $(this)
        .parent()
        .parent()
        .css({
          background:
            'transparent url("' +
            imgSrc +
            '") no-repeat center center/' +
            fitType,
        });
      $(this).remove();
    });
  }

  function ImgObjectFit_noAnchor() {
    $("img.obj-fit-no-anchor").each(function () {
      var imgSrc = $(this).attr("src");
      var fitType = "cover";
      $(this)
        .parent()
        .css({
          background:
            'transparent url("' +
            imgSrc +
            '") no-repeat center center/' +
            fitType,
        });
      $(this).remove();
    });
  }

  if (
    navigator.appName == "Microsoft Internet Explorer" ||
    !!(
      navigator.userAgent.match(/Trident/) || navigator.userAgent.match(/rv:11/)
    ) ||
    (typeof $.browser !== "undefined" && $.browser.msie == 1)
  ) {
    $("body").addClass("IE");
    ImgObjectFit_Anchor();
    ImgObjectFit_noAnchor();
  }

  // On click of accordion slide toggle
  $(".sm-accordion--title").on("click", function () {
    if ($(".sm-accordion").hasClass("active")) {
      $(this).parent(".sm-accordion").removeClass("active");
    } else {
      $(this).parent(".sm-accordion").addClass("active");
    }
    flkty.resize();
  });

  if (
    $("body").hasClass("single-sunday-mass") &&
    $(".sundaymass-video--container").hasClass("multiple")
  ) {
    flkty.on("change", function () {
      $(".sm-accordion").removeClass("active");
      flkty.on("settle", function () {
        flkty.resize();
      });
    });
  }

  if ($("body").hasClass("category-sunday-mass")) {
    var hash = location.hash;
    var clean_hash = hash.replace(/[#]/g, "").toLowerCase();

    if (hash.length > 0) {
      $("#sm-select-categories").val(clean_hash);
      $(".sm-archive--link-container").show();
      var that = $("#sm-select-categories");
      var ajaxUrl = that.data("url");
      var selectedCategory = clean_hash;
      var archiveContainer = $(".sm-archive--container");
      var archiveArticles = $(".sm-archive--container article");
      var loading = $(".loader").addClass("loading");
      $("#sm-load-more").hide();
      archiveArticles.remove();
      $.ajax({
        url: ajaxUrl,
        type: "post",
        data: {
          category: selectedCategory,
          action: "sm_load_category",
        },
        error: function (response) {
        },
        success: function (response) {
          if (selectedCategory == 18) {
            $("#sm-load-more").show();
          } else {
            $(".sm-archive--link-container").hide();
          }
          archiveContainer.append(response);
          loading.removeClass("loading");
          if (response.length == 0) {
            that.text("There are no more posts");
          }
        },
      });
    }
  }

  // Is the element visible
  function isVisible(element) {
    var scroll_pos = $(window).scrollTop();
    var window_height = $(window).height();
    var el_top = $(element).offset().top;
    var el_height = $(element).height();
    var el_bottom = el_top + el_height;
    return (
      el_bottom - el_height * 0.25 > scroll_pos &&
      el_top < scroll_pos + 0.5 * window_height
    );
  }

  // On change of category in Sunday Mass archive
  $("#sm-select-categories").change(function () {
    $(".sm-archive--link-container").show();
    var that = $(this);
    var ajaxUrl = that.data("url");
    var selectedCategory = that.val();
    var archiveContainer = $(".sm-archive--container");
    var archiveArticles = $(".sm-archive--container article");
    var loading = $(".loader").addClass("loading");
    $("#sm-load-more").hide();
    archiveArticles.remove();
    $.ajax({
      url: ajaxUrl,
      type: "post",
      data: {
        category: selectedCategory,
        action: "sm_load_category",
      },
      error: function (response) {
      },
      success: function (response) {
        if (selectedCategory == 18) {
          $("#sm-load-more").show();
        } else {
          $(".sm-archive--link-container").hide();
        }
        archiveContainer.append(response);
        loading.removeClass("loading");
        if (response.length == 0) {
          that.text("There are no more posts");
        }
      },
    });
  });

  // DSD PHASE TWO

  $(".archive-header button").on("click", function (e) {
    e.preventDefault();
    var element;
    if ($("body").hasClass("page-template-blog-new")) {
      element = document.getElementById("latest");
    } else if ($("body").hasClass("page-template-resources-archive")) {
      element = document.getElementById("resource-links");
    } else if ($("body").hasClass("page-template-news-archive")) {
      element = document.getElementById("press-links");
    } else {
    }

    element.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  });

  // ISOTOPE WORK BEGINS

  var container = "";
  var itemSelector = "";

  // If it's newsroom
  if ($("body").hasClass("page-template-news-archive")) {
    container = document.querySelector(".container--news-archive");
    itemSelector = ".article-card";

    // If it's resources
  } else if ($("body").hasClass("page-template-resources-archive")) {
    container = document.querySelector(".container--resources-archive");
    itemSelector = ".article-card";

    // If it's experts
  } else if ($("body").hasClass("page-template-experts-archive")) {
    container = document.querySelector(".container--category-load");
    itemSelector = ".article-card--expert";

    // If it's the blog
  } else if ($("body").hasClass("page-template-blog-new")) {
    container = document.querySelector(".container--initial");
    itemSelector = ".article-card";

    // If it's a search result
  } else if ($("body").hasClass("search-results")) {
    container = document.querySelector(".container--blog-latest");
    var search_result_type = $("#search-bar").data("search");
    if (search_result_type == "experts") {
      itemSelector = ".article-card--expert";
    } else {
      itemSelector = ".article-card";
    }
  } else {
  }

  if (
    $("body").hasClass("page-template-blog-new") ||
    $("body").hasClass("page-template-experts-archive") ||
    $("body").hasClass("page-template-resources-archive") ||
    $("body").hasClass("page-template-news-archive") ||
    $("body").hasClass("search-results")
  ) {
    var iso = new Isotope(container, {
      itemSelector: itemSelector,
      layoutMode: "fitRows",
      transitionDuration: "0.2s",
      hiddenStyle: {
        opacity: 0,
      },
    });
  }

  loader();
  search_filters();

  $(".single-blog-accordion--title").on("click", function () {
    $(".single-blog-accordion--text").slideToggle();

    if ($(".single-blog-accordion").hasClass("active")) {
      $(this).parent(".single-blog-accordion").removeClass("active");
    } else {
      $(this).parent(".single-blog-accordion").addClass("active");
    }
  });

  $("section.in-the-news #in-the-news-loader").on("click", function () {
    $(".in-the-news--inner article:hidden").show();

    $(this).parent().hide();
  });

  var selectedCategoryFilterFocus = "";

  function loader() {
    var LoadMoreBtn = $("#loader-btn");

    //  LOAD MORE posts
    LoadMoreBtn.on("click", function () {
      var number_of_posts_shown = "";
      var number_of_featured_posts = "";
      var selectedCategory = "";
      var post_type = "";
      var that = $(this);
      var page = that.data("page");
      var newPage = page + 1; //  update page num for 'load more' newest batch
      var ajaxUrl = that.data("url");

      if ($("body").hasClass("page-template-resources-archive")) {
        number_of_posts_shown = $(
          ".container--resources-archive .article-card"
        ).length;
        number_of_resource_posts = $(
          '.container--resources-archive .article-card[data-post-type="resource"]'
        ).length;
        number_of_blog_posts = $(
          '.container--resources-archive .article-card[data-post-type="post"]'
        ).length;

        //selectedCategory = 17;
        //selectedCategory = "all";
        post_type = "resource";

        $.ajax({
          url: ajaxUrl,
          type: "post",
          data: {
            page: newPage,
            post_type: post_type,
            action: "loader_resources",
            //action : 'loader',
            number_resource_posts: number_of_resource_posts,
            number_posts: number_of_blog_posts,
            featured: featured_ids,
            offset: number_of_posts_shown,
            category: selectedCategory,
          },
          error: function (response) {
          },
          success: function (response) {
            that.show();
            that.data("page", newPage);

            var responses = $(response);
            iso.insert(responses);
            iso.layout();

            //  handle loading state
            $(".loader").removeClass("loading");
            LoadMoreBtn.removeClass("hidden");

            if (response.length == 0) {
              that.text("There are no more posts");
            } else {
              that.text("Load More +");
            }
          },
        }); // End of Ajax call
      } else if ($("body").hasClass("page-template-blog-new")) {
        number_of_posts_shown = $(
          ".container--blog-latest .article-card"
        ).length;
        number_of_featured_posts = $(
          ".container--blog-featured .article-card"
        ).length;
        added_posts = $(".container--initial .article-card").length;
        number_of_posts_shown = number_of_posts_shown + added_posts;

        if (selectedCategoryFilterFocus == "") {
          selectedCategory = "all";
        } else {
          selectedCategory = selectedCategoryFilterFocus;
        }

        if (number_of_featured_posts > 0) {
          var featured_ids = $(".container--blog-featured .article-card")
            .map(function () {
              return $(this).data("id");
            })
            .toArray();
        }

        $.ajax({
          url: ajaxUrl,
          type: "post",
          data: {
            page: newPage,
            post_type: "post",
            dataType: "json",
            action: "loader",
            featured: featured_ids,
            offset: number_of_posts_shown,
            category: selectedCategory,
          },
          error: function (response) {},
          success: function (response) {
            that.show();
            that.data("page", newPage);

            var responses = $(response);
            iso.insert(responses);
            iso.layout();
            iso.arrange({
              filter: "*",
            });

            //  handle loading state
            $(".loader").removeClass("loading");
            LoadMoreBtn.removeClass("hidden");

            if (response.length == 0) {
              that.text("There are no more posts");
            } else {
              that.text("Load More +");
            }

            var selectedCategory = $("#category-collection").val();
            cat_name = selectedCategory.replace(/-/g, " ");
            cat_permalink = $(location).prop("href");

            //update all category links.
            $(".home-article--cat-link").each(function () {
              if (
                $(this).html().toLowerCase() != cat_name &&
                cat_name != "all"
              ) {
                //category link different from selected category. Update here
                $(this).attr("href", cat_permalink);
                $(this).html(cat_name);
              }
            });
          },
        }); // End of Ajax call
      } else if ($("body").hasClass("page-template-news-archive")) {
        number_of_posts_shown = $(
          ".container--news-archive .article-card"
        ).length;
        number_of_resource_posts = $(
          '.container--news-archive .article-card[data-post-type="news"]'
        ).length;
        number_of_blog_posts = $(
          '.container--news-archive .article-card[data-post-type="post"]'
        ).length;

        selectedCategory = 49;
        post_type = "news";

        $.ajax({
          url: ajaxUrl,
          type: "post",
          data: {
            page: newPage,
            post_type: post_type,
            //action : 'loader_resources',
            action: "loader",
            number_resource_posts: number_of_resource_posts,
            number_posts: number_of_blog_posts,
            featured: featured_ids,
            offset: number_of_posts_shown,
            category: selectedCategory,
          },
          error: function (response) {},
          success: function (response) {
            that.show();
            that.data("page", newPage);

            var responses = $(response);
            iso.insert(responses);
            iso.layout();

            //  handle loading state
            $(".loader").removeClass("loading");
            LoadMoreBtn.removeClass("hidden");

            if (response.length == 0) {
              that.text("There are no more posts");
            } else {
              that.text("Load More +");
            }
          },
        }); // End of Ajax call
      } else if ($("body").hasClass("single-experts")) {
        number_of_posts_shown = $(
          ".container--single-expert .article-card"
        ).length;
        var expert_id = $(".container--single-expert").data("expert");

        $.ajax({
          url: ajaxUrl,
          type: "post",
          data: {
            action: "loader_experts",
            offset: number_of_posts_shown,
            expert: expert_id,
          },
          error: function (response) {},
          success: function (response) {
            //testing console ajax object
            $(".container--single-expert").append(response);

            //  handle loading state
            $(".loader").removeClass("loading");
            LoadMoreBtn.removeClass("hidden");

            if (response.length == 0) {
              that.text("There are no more posts");
            } else if (response.length < 6) {
              $(".loader--container").hide();
            } else {
              that.text("Load More +");
            }
          },
        }); // End of Ajax call
      } else {
      }

      //  handle loading state
      $(".loader").addClass("loading");
      LoadMoreBtn.addClass("hidden");
    }); // End of on click
  }

  function search_filters() {
    // Getting all posts for Isotope filtering
    var getPostsForIsotope = function (video_check) {
      var ajaxUrl = $(".search-bar").data("url");
      var post_type = "";
      var category = "";
      var only_videos = video_check;
      var loader = $("main .loader--container");

      // If it's newsroom
      if ($("body").hasClass("page-template-news-archive")) {
        post_type = "news";
        category = "news";

        // If it's resources
      } else if ($("body").hasClass("page-template-resources-archive")) {
        post_type = "resource";
        category = "resources";

        // If it's experts
      } else if ($("body").hasClass("page-template-experts-archive")) {
        post_type = "experts";
        category = "";

        // If it's the blog
      } else if ($("body").hasClass("page-template-blog-new")) {
        post_type = "post";
        category = $("#category-collection").val();
      } else {
      }

      $.ajax({
        url: ajaxUrl,
        type: "post",
        data: {
          post_type: post_type,
          category: category,
          only_videos: video_check,
          action: "loader_filtering",
        },
        beforeSend: function () {
          loader.show();
          $("main .loader").addClass("loading");
          $("#loader-btn").hide();
          if ($("body").hasClass("page-template-experts-archive")) {
            var $currentItems = $(".article-card--expert");
          } else {
            var $currentItems = $(".article-card");
          }

          iso.remove($currentItems);
        },
        error: function (response) {
        },
        success: function (response) {
          loader.hide();
          var $items = $(response);
          var itemsLength = $items.length;
          if (itemsLength != 0) {
            iso.insert($items);
            // loader.hide();
            loader.show();
            $(".loader").removeClass("loading");
            $("#loader-btn").show();
          } else {
            loader.show();
            $("#loader-btn").show();
            $("#loader-btn").text("There are no posts that match");
          }
          $(".loader").removeClass("loading");

          cat_permalink = $(location).prop("href");

          //update all category links.
          $(".home-article--cat-link").each(function () {
            if ($(this).html().toLowerCase() != cat_name && cat_name != "all") {
              //category link different from selected category. Update here
              $(this).attr("href", cat_permalink);
              $(this).html(cat_name);
            }
          });
        },
      });
    };

    // =======When articles are sorted, updated the url with the sorted param
    var updateUrlWithParams = function (key, value) {
      location.hash = "";
      var url = window.location.href;
      if (url.indexOf("?") == -1) {
        window.history.pushState({}, null, url + "?" + key + "=" + value);
      } else {
        url = url.split("?");
        url = url[0];
        window.history.pushState({}, null, url + "?" + key + "=" + value);
      }
    };

    var category_filter = function () {
      var selectedCategory = $("#category-collection").val();
      selectedCategoryFilterFocus = selectedCategory;
      var categoryName = selectedCategory.replace(/-/g, " ");
      $(".page-title").html(categoryName);

      if (selectedCategory == "all") {
        if ($("body").hasClass("page-template-blog-new")) {
          $(".container--initial").show();
        }

        iso.arrange({
          filter: "*",
        });
      } else {
        if (
          $("body").hasClass("page-template-blog-new") ||
          $("body").hasClass("page-template-experts-archive")
        ) {
          // $('.container--initial').hide();
        }

        iso.arrange({
          filter: "*",
        });
      }

      updateUrlWithParams("category", selectedCategory);
    };

    // ==== ***url param stuff***
    // ===== On load, grab the param in the url and sort
    $.urlParam = function (name) {
      var results = new RegExp("[?&]" + name + "=([^&#]*)").exec(
        window.location.href
      );
      if (results == null) {
        return null;
      } else {
        if (name == "content") {
          if (results[1] == "all--video") {
            $(".search-bar--filters button").addClass("active");

            if ($("body").hasClass("page-template-blog-new")) {
              getPostsForIsotope(true);
              $(".container--initial").hide();
            }
          } else {
            $(
              '.search-bar--filters button[data-material="' + results[1] + '"]'
            ).addClass("active");
          }

          iso.arrange({
            filter: "." + results[1],
          });
        } else if (name == "category") {
          $("#category-collection option[value=" + results[1] + "]").prop(
            "selected",
            true
          );

          if (results[1] != "all") {
            getPostsForIsotope();
          }

          category_filter();
        }
      }
    };

    $.urlParam("category");
    $.urlParam("content");

    // Search bar buttons on resources
    $(".search-bar--filters button").on("click", function () {
      $(".search-bar--filters button").not(this).removeClass("active");

      // Set the category dropdown to all
      $("#category-collection").val("all");

      // Get the selected filter on the button
      var selected_filter = $(this).data("filter");

      // Toggle on or off the active state
      $(this).toggleClass("active");

      if (
        $("body").hasClass("page-template-news-archive") ||
        $("body").hasClass("page-template-blog-new")
      ) {
        // If the button is activated
        if ($(this).hasClass("active")) {
          if ($("body").hasClass("page-template-blog-new")) {
            getPostsForIsotope(true);
            $(".container--initial").hide();
          } else {
            getPostsForIsotope(false);
          }

          $(this).text("Videos only");
          iso.arrange({
            filter: "." + selected_filter,
          });

          updateUrlWithParams("content", selected_filter);

          // If the button is de-activated
        } else {
          if ($("body").hasClass("page-template-blog-new")) {
            $(".container--initial").show();
            $(".loader--container").show();
            $(".loader--container #loader-btn").show();
            $("#loader-btn").text("Load More +");
            var $currentItems = $(".container--initial .article-card");
            iso.remove($currentItems);
            iso.layout();
            updateUrlWithParams("", "");
          } else {
            $(this).text("All posts");
            iso.arrange({
              filter: "*",
            });
          }
        }
      } else if ($("body").hasClass("page-template-resources-archive")) {
        // If the button is activated
        if ($(this).hasClass("active")) {
          getPostsForIsotope(false);

          iso.arrange({
            filter: "." + selected_filter,
          });

          updateUrlWithParams("content", selected_filter);

          // If the button is de-activated
        } else {
          iso.arrange({
            filter: "*",
          });

          updateUrlWithParams("", "");
        }
      } else if ($("body").hasClass("search-results")) {
        var selected_filter = $(this).data("filter");
        var search_check = $("#search-bar").data("search");

        if ($(this).hasClass("active")) {
          if (search_check == "resource") {
          } else {
            $(this).text("Videos only");
          }

          $("nav.pagination").hide();
          iso.arrange({
            filter: "." + selected_filter,
          });

          iso.on("arrangeComplete", function () {
            var articles_showing = $(".article-card:visible").length;

            if (articles_showing == 0) {
              $(".loader--container").show();
              $("#loader-btn").show();
              $("#loader-btn").text("There are no posts that match");
            }
          });
        } else {
          $("nav.pagination").show();

          if (search_check == "resource") {
          } else {
            $(this).text("All posts");
          }

          iso.arrange({
            filter: "*",
          });
        }
      } else {
      }
    });

    //store values from category selection
    var cat_selected = false;
    var cat_name;
    var cat_permalink;

    // Search bar category work
    $("#category-collection").change(function () {

      // If this is occuring on a search results page
      if ($("body").hasClass("search-results")) {

        $(".loader--container").hide();
        var selectedCategory = $("#category-collection").val();

        if (selectedCategory == "all") {
          iso.arrange({
            filter: "*",
          });
        } else {
          iso.arrange({
            filter: "." + selectedCategory,
          });

          iso.on("arrangeComplete", function () {
            var search_type = $("#search-bar").data("search");

            if (search_type == "experts") {
              var articles_showing = $(".article-card--expert:visible").length;
            } else {
              var articles_showing = $(".article-card:visible").length;
            }

            if (articles_showing == 0) {
              $(".loader--container").show();
              $("#loader-btn").show();
              $("#loader-btn").text("There are no posts that match");
            }
          });
        }

        // Else on all other pages
      } else {
        // Remove active state for filter buttons
        $(".search-bar--filters button").removeClass("active");

        // Testing if it's not the blog page with an all category
        var testing_for_blog_all = $("#category-collection").val();

        if (
          $("body").hasClass("page-template-blog-new") &&
          testing_for_blog_all == "all"
        ) {
          $(".container--initial").show();
          $(".loader--container").show();
          $(".loader--container #loader-btn").show();
          var $currentItems = $(".container--category-load .article-card");
          iso.remove($currentItems);
          iso.layout();
          updateUrlWithParams("", "");
        } else if (
          $("body").hasClass("page-template-experts-archive") &&
          testing_for_blog_all == "all"
        ) {
          $(".container--initial").show();
          $(".loader--container").hide();
          $(".loader--container #loader-btn").hide();
          var $currentItems = $(
            ".container--category-load .article-card--expert"
          );
          iso.remove($currentItems);
          iso.layout();
          updateUrlWithParams("", "");
        } else {
          getPostsForIsotope();
        }

        category_filter();

        var selectedCategory = $("#category-collection").val();
        // cat_permalink = $('#category-collection').find(':selected').data(selectedCategory).attr('data-category-url');

        cat_name = selectedCategory.replace(/-/g, " ");
        cat_selected = true;
      }
    });
  }

  //prepare lazyload images(Our History and Leadership pages)
  $(".js-load-right, .js-load-left").addClass("js-lazy-load");
  $(window).scroll(function () {
    $(".js-lazy-load").each(function (i) {
      if (
        $(this).offset().top <
        $(window).scrollTop() + $(window).height() * 0.8
      ) {
        $(this).addClass("scrolled-past");
      }
    });
  });

  $(".avia_message_box").each(function () {
    var e = $(this);
    e.find(".av_message_close").click(function () {
      e.css({ display: "none" });
    });
  });

  //virtual tour rezize
  if ($(".vtour").length > 0) {
    $(window).resize(function () {
      if ($(window).width() < 600) {
        $(".vtour").attr("height", "400");
      } else {
        $(".vtour").attr("height", "580");
      }
    });
  }

  $(window).scroll(function () {
    if ($(window).scrollTop() > 300) {
      $("#scroll-top-link").addClass("visible");
    } else {
      $("#scroll-top-link").removeClass("visible");
    }
  });
  $("#scroll-top-link").click(function (e) {
    e.preventDefault();
    $("html, body").animate(
      {
        scrollTop: 0,
      },
      500
    );
  });

  // Community Resources Search

  function communitySearch() {
    var query = $(".community-wrapper input.search-query").val();
    var zipcode = $(".community-wrapper input.zip-code").val();
    var isValidZip = /(^\d{5}$)|(^\d{5}-\d{4}$)/.test(zipcode);
    if (isValidZip == false && $("input.zip-code").val().length > 0) {
      $(".invalid-zip").show();
      return false;
    }
    if (isValidZip == true || $("input.zip-code").val().length === 0) {
      var search_url =
        "/community-resources/search-results/?search=" +
        query +
        "&zip=" +
        zipcode;
      $(".invalid-zip").hide();
      window.location.href = search_url;
    }
  }

  $(".community-wrapper .top-search-submit").click(function () {
    communitySearch();
  });

  $(
    ".community-wrapper input.search-query, .community-wrapper input.zip-code"
  ).on("keypress", function (e) {
    if (e.which == 13) {
      communitySearch();
    }
  });

  // Community Resources - switch between List and Map on Search Results

  $(".list-map-buttons .icon-link.list").on("click", function (e) {
    e.preventDefault();
    if (!$(this).hasClass("inactive")) {
      $(this).addClass("inactive");
      $(".list-map-buttons .icon-link.map").removeClass("inactive");
      $("#map").hide();
    }
  });

  $(".list-map-buttons .icon-link.map").on("click", function (e) {
    e.preventDefault();
    if (!$(this).hasClass("inactive")) {
      $(this).addClass("inactive");
      $(".list-map-buttons .icon-link.list").removeClass("inactive");
      $("#map").show();
    }
  });

  // Community Resource - Important Alert Link

  $(".alert-reveal").on("click", function (e) {
    e.preventDefault();
    if (!$(this).hasClass("active")) {
      $(this).addClass("active");
      $(".important-alert-content").slideDown();
    } else if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(".important-alert-content").slideUp();
    }
  });

  // When clicking on the sub-menu area around the links in the main nav, its triggering the main menu link.
  // This prevents that from happening.
  $("ul.sub-menu.sub-menu-container").click(function (e) {
    if ($(e.target).is("a") || $(e.target).is("span")) {
      return true;
    } else {
      return false;
    }
  });

  resizePinterest();
  function resizePinterest() {
    console.log("In the pinterest resizer.");
    let pEmbeds = document.querySelectorAll(".wp-block-embed-pinterest iframe");
    pEmbeds.forEach(function (pEmbed) {
      //get width and height attribute of the iframe
      let pEmbedWidth = pEmbed.width;
      let pEmbedHeight = pEmbed.height;

      //get the actual width of the iframe
      let actualWidth = pEmbed.offsetWidth;

      //get the aspect ratio
      let aspectRatio = pEmbedHeight / pEmbedWidth;

      //get the calculated height
      let newHeight = actualWidth * aspectRatio;
      console.log("New Height: ", newHeight);
      console.log("Actual Width: ", actualWidth);

      //set the new height
      pEmbed.style.height = parseInt(newHeight + 24) + "px";
    });
  }

  // don't load home page mp4 video on mobile
  $(window)
    .resize(function () {
      resizePinterest();
      var screen_width = window.innerWidth;
      if (screen_width <= 900) {
        $("video.video-header").hide();
      } else {
        $("video.video-header").show();
      }
    })
    .resize();
}); // End of Document Ready
